<template>
  <div class="navigation" :class="{ navigation__isShow: navigationIsShow }">
    <div class="navigation__title" v-b-toggle.collapse-longTermCare>
      長照管理
    </div>

    <b-collapse class="navigation__links" id="collapse-longTermCare">
      <router-link class="navigation__link" :to="{ name: 'LongTerm' }">
        長照單管理
      </router-link>
      <router-link class="navigation__link" :to="{ name: 'LongTermUsers' }">
        長照用戶管理
      </router-link>
      <router-link class="navigation__link" :to="{ name: 'ImportOrders' }">
        匯入訂單資料
      </router-link>
      <router-link class="navigation__link" :to="{ name: 'ImportUsers' }">
        匯入用戶資料
      </router-link>
    </b-collapse>

    <!-- <div class="navigation__title" v-b-toggle.collapse-driver>
      公告/司機訊息
    </div> -->

    <!-- <b-collapse class="navigation__links" id="collapse-driver">
      <router-link class="navigation__link" :to="{ name: 'LongTerm' }">
        車隊公告
      </router-link>
      <router-link class="navigation__link" :to="{ name: 'LongTermUsers' }">
        司機訊息傳送
      </router-link>
    </b-collapse> -->
  </div>
</template>

<script>
export default {
  name: 'Navigation',
  props: {
    navigationIsShow: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.navigation {
  position: fixed;
  height: 100%;
  overflow: scroll;
  transition: transform 0.3s;
  transform: translateX(-100%);
  padding: 85px 20px 0;

  &__title {
    margin: 10px 0px;
    color: $text-dark;
    font-size: 16px;
    &:focus {
      outline: none;
    }
  }

  &__links {
    background-color: $white;
    padding: 0 10px;
    border: 1px solid $border-light;
    border-radius: 5px;
  }

  &__link {
    display: block;
    color: $text-regular;
    margin: 10px 0;
  }

  &__isShow {
    transform: translateX(0);
  }
}
</style>
